export default __webpack_public_path__ + "static/cabin-tiny-home-2-people-1-e677fd7999176a0093b14311abe88013.jpg";